<template>
  <div class="communicationManagement-page" v-allow="'080204'" style="width: 100%">
    <div class="all-content-container">
      <div class="table-content-container">
        <div class="table-title-container">
          <div class="table-title-title">
            <h4>通信网关</h4>
            <router-link to="addGatewayManagement">
              <el-button type="primary" class="addBtn">添加</el-button>
            </router-link>
          </div>
          <div class="table-content-title">
            <el-form :inline="true" class="demo-form-inline">
              <el-form-item label="设备名称：">
                <el-input v-model="gatewayName" placeholder="请输入设备名称" maxlength="20" clearable></el-input>
              </el-form-item>
              <el-form-item label="设备编码：">
                <el-input v-model="gatewayCode" placeholder="请输入设备编码" maxlength="20" clearable></el-input>
              </el-form-item>
              <el-form-item label="所属分组：">
                <el-cascader @change="changeTreeItem" :show-all-levels="false" v-model="groupId" :options="departList"
                  :props="optionProps" clearable placeholder="请选择所属分组"></el-cascader>
              </el-form-item>
              <el-form-item class="mar-l">
                <el-button type="primary" @click="onSubmit">查询</el-button>
                <el-button @click="resetonSubmit">重置</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
        <div class="table-content">
          <div class="table-table">
            <el-table :data="tableData" style="width: 100%" :header-cell-style="{ background: '#f4f5f7' }">
              <el-table-column align="center" label="序号" width="95">
                <template slot-scope="scope">
                  {{ scope.$index + 1 }}
                </template>
              </el-table-column>
              <el-table-column prop="gatewayName" label="设备名称" align="center" show-overflow-tooltip></el-table-column>
              <el-table-column prop="gatewayCode" label="设备编码" align="center" show-overflow-tooltip></el-table-column>
              <el-table-column prop="gatewayName" label="网关ID" align="center" show-overflow-tooltip></el-table-column>
              <el-table-column prop="status" label="网关状态" align="center">
                <template slot-scope="scope">
                  <span v-if="scope.row.status == 0">离线</span>
                  <span v-if="scope.row.status == 1">在线</span>
                  <span v-if="scope.row.status == 2">告警</span>
                </template>
              </el-table-column>
              <el-table-column prop="protocolType" label="协议类型" align="center">
                <template slot-scope="scope">
                  <span>{{ scope.row.protocolType | protocolTypes }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="lastHeartBeatTime" label="最近心跳时间" align="center"
                show-overflow-tooltip></el-table-column>
              <el-table-column prop="groupName" label="所属分组" align="center" show-overflow-tooltip></el-table-column>
              <el-table-column prop="isOpen" label="工作状态" align="center">
                <template slot-scope="scope">
                  <div v-if="scope.row.isOpen == 0">
                    <span class="show-line show-rline"></span>
                    停用
                  </div>
                  <div v-if="scope.row.isOpen == 1">
                    <span class="show-line show-bline"></span>
                    启用
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center" width="300px" fixed="right">
                <template slot-scope="scope">
                  <el-button type="text" :underline="false" size="small" class="marginLr"
                    @click="edit(scope.row.id)">编辑</el-button>
                  <el-button type="text" :underline="false" size="small" class="marginLr"
                    @click="deletes(scope.row.id)">删除</el-button>
                  <el-button type="text" :underline="false" size="small" class="marginLr" v-if="scope.row.isOpen == 1"
                    @click="onOrOffNumericalBth8(scope.row.id)">停用</el-button>
                  <el-button type="text" :underline="false" size="small" class="marginLr" v-if="scope.row.isOpen == 0"
                    @click="onOrOffNumericalBth7(scope.row.id)">启用</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div class="pagination-content-container" style="float: right; margin-top: 15px">
          <el-pagination background layout="prev, pager, next,jumper" class="pageTap"
            @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pagesize"
            :total="total"></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      optionProps: {
        value: "id",
        label: "name",
        children: "children",
        checkStrictly: true,
      },
      departList: [],
      currentPage: 1,
      total: 0,
      pagesize: 8,
      gatewayName: "",
      gatewayCode: "",
      groupId: "",

      input: "",
      input1: "",
      input2: "",
      tableData: [],
    };
  },
  created() {
    this.getGatewayList();
    this.getConfigGroupTree();
  },
  mounted() {
    this.getGatewayList();
    this.getConfigGroupTree();
  },
  methods: {
    //i所属分组id
    changeTreeItem(val) {
      this.groupId = val[val.length - 1];
    },

    //清除
    empty() {
      this.gatewayName = ""; //设备编码
      this.groupId = ""; // 分组id
      this.gatewayCode = ""; //名称
    },
    //  重置
    resetonSubmit() {
      this.empty();
      this.onSubmit();
    },
    //查询
    onSubmit() {
      this.getGatewayList();
    },
    //分页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getGatewayList();
    },
    //删除
    deletes(id) {
      this.$confirm("是否删除？", "", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$api.system
            .delfun(`/pc/objDeviceGateway/delGateway`, id)
            .then((res) => {
              if (res.code == 200) {
                this.getGatewayList();
                this.$message({
                  type: "success",
                  message: res.msg,
                });
              } else {
                // this.$message.error(res.msg)
              }
            });
        })
        .catch(() => {
          this.$message.info("已取消删除");
        });
    },
    //启用/停用
    onOrOffNumericalBth7(id) {
      this.$confirm("是否启用？", "", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.openOrCloseGateway(id);
        })
        .catch(() => {
          this.$message.info("已取消启用");
        });
    },
    onOrOffNumericalBth8(id) {
      this.$confirm("是否停用？", "", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.openOrCloseGateway(id);
        })
        .catch(() => {
          this.$message.info("已取消停用");
        });
    },
    //启用/停用 接口id
    openOrCloseGateway(id) {
      this.$api.system
        .openOrCloseGateway(id)
        .then((res) => {
          if (res.code == 200) {
            this.getGatewayList();
            this.$message({
              type: "success",
              message: res.msg,
            });
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    // 编辑
    edit(id) {
      this.$router.push({
        path: "addGatewayManagement",
        query: {
          id: id,
        },
      });
    },
    //添加
    addVideo() {
      this.$router.push({
        path: "addGatewayManagement",
        query: {},
      });
    },
    // 查询通信网关列表
    getGatewayList() {
      this.$api.system
        .getGatewayList(
          this.currentPage, //第几页，默认1
          this.pagesize, //默认展示多少条，默认10
          this.gatewayCode, //网关编码 暂时填和网关id一样
          this.gatewayName, // 网关名称
          this.groupId //名称
        )
        .then((res) => {
          if (res.code == 200) {
            this.tableData = res.data;
            this.total = res.count;
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    //查询设备分组树，查询1
    getConfigGroupTree() {
      this.$api.system
        .getConfigGroupTree(
          0, //主键id ，根据具体业务进行判定
        )
        .then((res) => {
          if (res.code == 200) {
            this.departList = res.data;
          } else {
            // this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/style/communicationManagement.scss";
</style>